import { Box, useTheme } from "@mui/material";
import React from "react";

interface Props {
  isVisible: boolean;
  children: React.ReactNode;
  onMouseLeave: (e: any) => void;
  onMouseEnter: (e: any) => void;
}

export const FloatingBar = React.forwardRef(
  ({ isVisible, children, onMouseLeave, onMouseEnter }: Props, ref: any) => {
    const theme = useTheme();
    const [layoutProps, setLayoutProps] = React.useState({
      top: 0,
      left: 0,
      width: 0,
    });

    React.useEffect(() => {
      const handler = () => {
        if (ref.current) setLayoutProps(calcLayoutProps(ref.current));
      };
      const timer = setTimeout(() => {
        handler(); // calling as onload
        window.addEventListener("resize", handler);
      }, 400);

      return () => {
        clearTimeout(timer);
        window.removeEventListener("resize", handler);
      };
    }, []);

    return (
      <Box
        id={"portal-floting-bar"}
        sx={{
          margin: `0px !important`,
          position: "absolute",
          top: `calc(${layoutProps.top}px - 1px)`,
          left: `${layoutProps.left}px - 1px `,
          width: `${layoutProps.width}px`,
          zIndex: 99,
          backgroundColor: theme.palette.background.paper,
          opacity: isVisible ? 1 : 0,
          pointerEvents: isVisible ? "all" : "none",
          transition: "opacity 0.3s ease",
        }}
        onMouseLeave={onMouseLeave}
        onMouseEnter={onMouseEnter}
      >
        {children}
      </Box>
    );
  }
);

FloatingBar.displayName = "FloatingBar";

function calcLayoutProps(parent: HTMLElement) {
  // parent width and height
  let pWidth = parent.offsetWidth;
  let pHeight = parent.offsetHeight;

  // parent position
  let pTop = parent.offsetTop;
  let pLeft = parent.offsetLeft;

  // props for the floating bar
  return {
    top: pTop + pHeight,
    left: pLeft,
    width: pWidth,
  };
}
